import { GoogleIcon } from "@/components/icons";
import { Button } from "@/components/ui/button";

type Props = {
  serverSideProps: {
    brandSuffix: string;
  };
};

const BrandName = ({ brandSuffix }: { brandSuffix: string }) => (
  <>
    sub<span className="text-[#8d949e]">+</span>
    {brandSuffix}
  </>
);

export default function (props: Props) {
  return (
    <div
      style={{ viewTransitionName: "nav-transition-admin-login" }}
      className="flex min-h-screen w-full items-center justify-center px-4 py-8"
    >
      <div className="w-full max-w-md border border-border/70 bg-background/95 p-8 shadow-sm md:p-10">
        <div className="flex flex-col gap-8">
          <div className="space-y-3 text-center text-primary">
            <div className="text-2xl font-semibold md:text-4xl">
              <BrandName brandSuffix={props.serverSideProps.brandSuffix} />
            </div>
            <div className="space-y-2">
              <div className="text-[11px] font-semibold uppercase tracking-[0.3em] text-primary/70">
                Administravimas
              </div>
            </div>
          </div>

          <div className="border border-border/70 bg-background p-5">
            <Button asChild className="w-full">
              <a href="/admin/gauth">
                <GoogleIcon className="size-5 fill-background" />
                Prisijungti su Google
              </a>
            </Button>
          </div>
        </div>
      </div>
    </div>
  );
}
